/**
 * Notifications: two kinds, and no switches.
 *
 * A settings screen usually shows four or five notification toggles. Three of
 * those would be for events this system does not emit at all, and the two that
 * are real have nowhere to store a preference - there is no per-kind column on
 * the server and no endpoint to write one.
 *
 * So the category states what produces a notification and why nothing else
 * does. The rule behind that is worth keeping when preferences do arrive: only
 * work that can take minutes and finishes while the reader is elsewhere earns
 * one. Capture and analysis finish under your eyes.
 */

import { Section } from "@/components/product";
import { Fact } from "./Fact";

export function NotificationsPanel() {
  return (
    <Section title="Bildirimler">
      <Fact
        label="Bildirim oluşturan olaylar"
        value="Rekonstrüksiyon tamamlandı · Rekonstrüksiyon başarısız"
      />
      <p className="muted">{"Bildirimler üstteki zil simgesinden okunur. Bildirim türleri kapatılamaz: yalnızca dakikalarca sürebilen ve başka bir ekrandayken biten işler bildirim üretir, çekim veya analiz üretmez."}</p>
      <p className="muted small settings__hint">{"E-posta bildirimi gönderilmez."}</p>
    </Section>
  );
}
